module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/restricted/restricted.component.css
// module id = ./src/app/restricted/restricted.component.css
// module chunks = main